import { Table, Typography } from 'antd';

const ASSET_LABELS: Record<string, string> = {
  uo: 'UO (钱包)',
  uoc: 'UOC',
  rp: 'RP',
  tp: 'TP',
  ep: 'EP',
  ep1: 'EP1',
  ep2: 'EP2',
  iep: 'IEP',
  sp1: 'SP1',
  sp2: 'SP2',
  sp3: 'SP3',
  mp: 'MP',
  ap: 'AP',
  fp: 'FP',
  fc: 'FC',
};

type AssetRow = {
  id: number;
  username: string;
  is_sub: boolean;
  assets: Record<string, string>;
  orb_wallet_display: string | null;
};

type Props = {
  rows: AssetRow[];
  totals: Record<string, string>;
  orbWalletTotal: string;
  title?: string;
};

function fmt(v: string): string {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return '—';
  if (Math.abs(n) >= 1) return n.toLocaleString(undefined, { maximumFractionDigits: 4 });
  return n.toPrecision(4);
}

export function AssetImpactSummary({ rows, totals, orbWalletTotal, title }: Props) {
  const nonzeroKeys = Object.keys(ASSET_LABELS).filter((k) => {
    const t = Number(totals[k] ?? '0');
    return Number.isFinite(t) && t !== 0;
  });

  return (
    <div style={{ marginTop: 12 }}>
      {title && (
        <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
          {title}
        </Typography.Text>
      )}
      <div style={{ marginBottom: 8, fontSize: 13 }}>
        <strong>ORB（主+子钱包算法）</strong> 合计减少：{' '}
        <span style={{ color: '#cf1322', fontWeight: 700 }}>
          {Number(orbWalletTotal).toLocaleString()}
        </span>
      </div>
      {nonzeroKeys.length > 0 && (
        <div style={{ marginBottom: 10, fontSize: 12, color: '#555' }}>
          平台余额将一并清除：
          {nonzeroKeys.map((k) => (
            <span key={k} style={{ marginLeft: 10 }}>
              {ASSET_LABELS[k]} <strong>{fmt(totals[k] ?? '0')}</strong>
            </span>
          ))}
        </div>
      )}
      <Table<AssetRow>
        size="small"
        pagination={false}
        rowKey="id"
        dataSource={rows}
        scroll={{ x: 720 }}
        columns={[
          {
            title: '账户',
            render: (_, r) => (
              <span>
                #{r.id} {r.username}
                {r.is_sub ? '（子）' : ''}
              </span>
            ),
          },
          {
            title: 'ORB 显示',
            render: (_, r) => (r.orb_wallet_display ? fmt(r.orb_wallet_display) : '—'),
          },
          ...['sp1', 'sp2', 'sp3', 'ep1', 'ep2', 'rp', 'tp', 'fc'].map((k) => ({
            title: ASSET_LABELS[k],
            render: (_: unknown, r: AssetRow) => fmt(r.assets[k] ?? '0'),
          })),
        ]}
      />
    </div>
  );
}
